/* ============================================================
   YAOSKIN — Global cart-drawer checkout-total fix
   Loaded site-wide (see layout/theme.liquid), not scoped to the
   product page, because the bug it patches can be triggered by
   ANY control that changes the cart: the drawer's own +/- and
   remove buttons, our custom product-page Add to Bag flow, etc.

   ROOT CAUSE (confirmed by direct DOM inspection, live):
   Palo Alto's cart drawer renders the checkout total TWICE —
   there are two `.cart__checkout` elements in the drawer markup
   (one always display:none, one visible). Whenever the cart
   total changes, Palo Alto's own update code (getCart() /
   buildTotalPrice()) only ever refreshes ONE of the two copies.
   Which one stays visible doesn't change, so in practice this
   shows up as "the checkout button" being stuck on a stale total
   after adding/increasing quantity, even though the per-line
   item price and the actual server-side cart (/cart.js) are both
   correct. Confirmed this is NOT specific to our custom Add to
   Bag button — the drawer's own native "Increase Quantity"
   button reproduces it identically, since both paths ultimately
   call Palo Alto's window.cart.getCart().

   FIX: rather than patch every call site that can trigger a cart
   change (which would need to cover Palo Alto's own native
   controls too, code we don't own), wrap window.cart.getCart()
   itself once. After the original getCart() runs (from whatever
   triggered it), fetch our own guaranteed-fresh /cart.js and copy
   whichever of the two duplicate checkout buttons already shows
   the CORRECT total into the other one. This sidesteps Palo
   Alto's broken selector instead of trying to out-guess it, and
   avoids re-implementing Shopify's money formatting ourselves
   (we copy already-correctly-rendered markup, not reconstruct it).
   ============================================================ */
(function () {
  function parseMoneyToCents(text) {
    var m = text.replace(/[^0-9.,]/g, '').match(/\d+([.,]\d{1,2})?/);
    if (!m) return null;
    return Math.round(parseFloat(m[0].replace(',', '.')) * 100);
  }

  function syncCheckoutTotal(freshCart) {
    var buttons = document.querySelectorAll('#cart-drawer .cart__checkout');
    if (buttons.length < 2) return;

    var correctSpan = null;
    buttons.forEach(function (btn) {
      var span = btn.querySelector('.cart__total__money');
      if (span && parseMoneyToCents(span.textContent) === freshCart.total_price) {
        correctSpan = span;
      }
    });
    if (!correctSpan) return; // no source of truth found; leave as-is rather than guess

    buttons.forEach(function (btn) {
      var span = btn.querySelector('.cart__total__money');
      if (span && span !== correctSpan && span.innerHTML !== correctSpan.innerHTML) {
        span.innerHTML = correctSpan.innerHTML;
      }
    });
  }

  function refreshCheckoutTotal() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(syncCheckoutTotal)
      .catch(function () {
        // Non-fatal: worst case the checkout total lags until the next
        // cart interaction, which will retry this same correction.
      });
  }

  function patchCartDrawer() {
    if (!window.cart || typeof window.cart.getCart !== 'function') return false;
    if (window.cart.__yaoskinCheckoutTotalPatched) return true;
    window.cart.__yaoskinCheckoutTotalPatched = true;

    var originalGetCart = window.cart.getCart.bind(window.cart);
    window.cart.getCart = function () {
      var result = originalGetCart.apply(window.cart, arguments);
      // getCart()'s own internal fetches are unsequenced and it returns no
      // promise we can chain onto, so we can't await it directly — schedule
      // our correction shortly after so it runs once those have settled.
      setTimeout(refreshCheckoutTotal, 400);
      return result;
    };
    return true;
  }

  // window.cart is assigned by Palo Alto's own theme.js, which is also a
  // deferred script — poll briefly rather than assuming exact load order
  // relative to this file.
  if (!patchCartDrawer()) {
    var tries = 0;
    var interval = setInterval(function () {
      tries++;
      if (patchCartDrawer() || tries > 40) clearInterval(interval);
    }, 100);
  }
})();
